import { Chip, Typography, styled, type TypographyProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAnnounceChange } from '~/components/LiveRegion';

export const CountChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'appsValue',
})<{ selected?: boolean }>(({ theme, selected }) => ({
  position: 'relative',
  marginRight: theme.spacing(2),
  padding: theme.spacing(2),
  fontSize: '16px',
  fontWeight: selected ? 'bold' : '500',
  backgroundColor: selected ? theme.palette.primary.selected : theme.palette.common.white,
  color: selected ? theme.palette.common.white : theme.palette.common.black,
  border: '1px solid #dfdfdf',
  '&:hover': {
    background: selected && theme.palette.primary.selected,
  },
  lineHeight: theme.spacing(3),
}));

export interface CountProps extends Omit<TypographyProps, 'children'> {
  selectedCount: number;
  totalCount: number;
  thing: string;
}

export const Count = ({ selectedCount, totalCount, thing, ...props }: CountProps) => {
  const { t } = useTranslation();
  const text = `${totalCount}\u00a0${t(thing, { count: totalCount })}${
    selectedCount > 0 ? `, ${t('common.status.selected_plural', { count: selectedCount })}` : ''
  }`;
  useAnnounceChange(text);
  return (
    <Typography component="p" variant="subtitle1" {...props}>
      {text}
    </Typography>
  );
};

// Punctuation between two counts: styled like them, but never a heading.
export const CountSeparator = () => {
  return (
    <Typography aria-hidden component="span" variant="h6" mt={0.5}>
      ,
    </Typography>
  );
};
